import { createTheme} from '@mui/material/styles';
import { green } from '@mui/material/colors';
import {teal} from '@mui/material/colors';


const light = createTheme({
  name: "Light",
  palette: {
    background: {
      default: "rgb(245,245,245)"
    },
  },


});

const dark = createTheme({
  name: "Dark",
  palette: {
    mode: 'dark',
  },
});

const nature = createTheme(
  {
    name: "Nature",
    palette: {
      primary: {
        main: green[800],
      },
      secondary: {
        main: teal[600],
      },
      background: {
        default: green[50],
      },
    },
  }
);

const themes = {
  light:light,
  nature:nature,
  dark:dark,
}

export default themes;